import { registerPlugin } from "@capacitor/core";
import { CapacitorNativeGoogleAuthPlugin } from "./definitions";

export const CapacitorNativeGoogleAuth = registerPlugin<CapacitorNativeGoogleAuthPlugin>(
    "CapacitorNativeGoogleAuth",
    {
        web: () => import("./web").then(m => new m.CapacitorNativeGoogleAuthWeb())
    }
);

export * from "./definitions";
